import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import ReactCodeInput from "react-verification-code-input";
import { Link } from "react-router-dom";
import { base_url } from "../Api/Api";
import { Loader } from "../Global/Loader";
import { Popup } from "../Global/Popup";
import Cookies from "universal-cookie";

// login not working yet

const Enterverfcode = (props) => {
  const [time, setTime] = useState("02:00");
  const [state, setState] = useState({
    temp: 0,
    loading: false,
    loader: false,
    Popup: false,
    validError: false,
    phoneNumber: JSON.parse(localStorage.getItem("phoneNumber")),
    verficationCode: null,
    errorText: "",
    errorCode: "",
  });
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("logined")) !== null) {
      props.history.push(`/MainPage`);
    }

    activateTimer();
    setTimeout(() => {
      setState({ ...state, loading: true });
    }, 300);
  }, []);
  const activateTimer = () => {
    let resendCountDown = 120;

    const interval = setInterval(() => {
      if (resendCountDown === 0) {
        clearInterval(interval);
        setTime("");
      } else {
        const minutes = Math.floor(resendCountDown / 60);
        const seconds = resendCountDown % 60;
        setTime(`0${minutes}:${seconds}`);
        resendCountDown--;
      }
    }, 1000);
  };

  const handleVerfCode = (value) => {
    setState({
      ...state,
      verficationCode: value,
      validError: false,
    });
  };

  const resendCode = () => {
    activateTimer();
    setState({
      ...state,
      validError: false,
    });

    const Data = {
      mobile: state.phoneNumber,
    };

    base_url.post("registerOrLogin", Data);
  };

  const contniue = () => {
    if (state.verficationCode !== null && state.verficationCode.length == 6) {
      localStorage.setItem("verfCode", JSON.stringify(state.verficationCode));
      setState({
        ...state,
        loader: true,
        validError: false,
      });
      const Data = {
        mobile: state.phoneNumber,
        code: state.verficationCode,
        webpush_id: localStorage.getItem("gcm_id"),
      };
      const headers = {
        Authorization: "",
        "content-type": "application/json",
      };
      base_url
        .post("checkVerifyCode", Data, {
          headers: headers,
        })
        .then((response) => {
          setState({
            ...state,
            loader: false,
          });
          if (response.data.registeredUser == false) {
            // not_registred
            props.history.push("/Entrance/step3");
          }
          const cookies = new Cookies();
          cookies.set("api_key", response.data.token, {
            maxAge: 604800,
            path: "/",
          });
          const headers = {
            Authorization: response.data.token,
            "content-type": "application/json",
          };
          base_url.get("splash", { headers: headers }).then((resp) => {
            if (resp.data.is_verify == 1 && response.data.registeredUser) {
              // nxot_is_verify
              localStorage.setItem("logined", JSON.stringify(true));
              setTimeout(() => {
                props.history.push("/");
                window.location.reload();
              }, 500);
            } else if (response.data.registeredUser) {
              // registred & verify

              localStorage.setItem("isVerfy", JSON.stringify(true));
              localStorage.removeItem("logined");
              props.history.push("/Entrance");
            }
          });
        });
    } else {
      setState({
        ...state,
        validError: true,
      });
    }
  };

  return (
    <div className={`entrnc-base verficode ${state.loading ? "active" : ""}`}>
      <Loader active={state.loader} />
      <Popup active={state.Popup}>
        <h4>خطا ( کد {state.errorCode} )</h4>
        <span>{state.errorText}</span>
        <div className="btn-base btn-border-black btn-sircle">
          <Button
            variant="contained"
            onClick={() => setState({ ...state, Popup: false })}
          >
            خروج
          </Button>
        </div>
      </Popup>
      <div className="titles-base titles-style-2">
        <h4>
          <Link to="/Entrance">
            <i className="icon-arrow-down-sign-to-navigate"></i>
          </Link>
          تکمیل اطلاعات
        </h4>
      </div>

      <div className="bx-info">
        <div className="form-info">
          <span>برای ورود کد ارسالی به شماره را وارد نمایید.</span>
          <strong>{state.phoneNumber}</strong>
          <ReactCodeInput onChange={(e) => handleVerfCode(e)} />
          {state.validError ? (
            <span className={`error-respns active`}>
              <i className="icon-exclamation-mark"></i>
              کد را بصورت کامل وارد کنید
            </span>
          ) : null}
          <div className="resend-time">
            <span className={`${!time ? "active" : ""}`} onClick={resendCode}>
              ارسال مجدد کد
            </span>
            {time ? <span>{time}</span> : <></>}
          </div>
        </div>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={contniue}>
            ادامه
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Enterverfcode;
